module.exports = __webpack_public_path__ + "img/choose-up-Up Social Trusou Cta-disabled.47ac394a.png";